module.exports = __webpack_public_path__ + "img/2.e6357b51.svg";